import { addListener, isVisible, height } from "@grindex-common/helpers/domManipulation";

import { ProductQuery } from "./ProductQuery.class";
import { debounce } from "@grindex-common/helpers/debounce";
import { events } from "@grindex-common/helpers/events";
import { Resolution } from "@grindex-common/helpers/Resolution.class";
import { refreshSlider, breakSettings } from "@grindex-client/components/Slider/slider";

function init($view) {
	const $module = $view[0];
	const carousels = [];
	const resolution = new Resolution();
	var query = new ProductQuery();

	addListener(window, events.TABS_SWITCHED, tabsSwitched.bind(this));
	addListener(window, events.ACCORDION_OPENED, redrawCarousel.bind(this));
	addListener(window, events.search.PARSED_QUERYSTRING, render.bind(this));
	addListener(window, "resize", debounce(redrawCarousel.bind(this), 400));

	// Initialize carousels on the page
	setupCarousels(".tab-content .cardSlider:not(.is-slider)", false);

	// Initialize carousels from the gray area
	setupCarousels(".gray-content-area .cardSlider", true);

	function setupCarousels(selector, handleFourBreaks) {
		initCarousel(document.querySelectorAll(selector), {
			auto: false,
			breaks: handleFourBreaks ? breakSettings.smallCardBreakSettings : breakSettings.contentAreaSmallCardBreakSettings,
			pager: false,
		}).map(($carousel) => {
			carousels.push($carousel);
		});
	}

	function tabsSwitched() {
		const $selectedTab = $module.querySelector(".tab-content");

		// make sure that existing carousels are redrawn on tab switch too
		redrawCarousel();

		if (isVisible($selectedTab)) {
			setupCarousels(".cardSlider:not(.is-slider)", false);
		}

		render(query.getQueryString());
	}

	function render(queryString) {
		query.setQuery(queryString);
		var timeout = window.setTimeout(
			function () {
				setCardHeight();
				clearTimeout(timeout);
			}.bind(this),
			10,
		);
	}

	function redrawCarousel() {
		carousels.forEach(($$carousel) => {
			if ($$carousel.is(":visible")) {
				$$carousel.redrawSlider();
			}
		});
	}

	function setCardHeight() {
		if (resolution.isLargerThan(resolution.tablet)) {
			var curElemHeight;
			var curAbstractHeight;
			var arrHeightValues = [];

			const $genericCards = Array.prototype.filter.call(
				document.querySelectorAll(".component-genericCardBlock, .component-brand-cards"),
				($genericCard) => {
					return isVisible($genericCard) && $genericCard.querySelectorAll("section.has-description").length;
				},
			);

			const $doubleWidthCards = Array.prototype.filter.call(document.querySelectorAll(".component-doubleWidthCardBlock"), ($doubleCard) => {
				return isVisible($doubleCard);
			});

			$genericCards.forEach(($genericCard) => {
				arrHeightValues.push(height($genericCard));
			});

			// Add any double-width cards into the stew so that if one of them
			// happens to be the tallest on the page, the other cards will take its height
			$doubleWidthCards.forEach(($doubleCard) => {
				arrHeightValues.push(height($doubleCard));
			});

			var largestHeight = Math.max.apply(null, arrHeightValues);

			$genericCards.forEach(($genericCard) => {
				curElemHeight = height($genericCard);
				if (curElemHeight < largestHeight) {
					curAbstractHeight = largestHeight - height($genericCard.querySelector("figure")) - 5;
					$genericCard.querySelector("abstract").style.height = curAbstractHeight + "px";
				}
			});

			$doubleWidthCards.forEach(($doubleCard) => {
				curElemHeight = height($doubleCard);
				if (curElemHeight < largestHeight) {
					$doubleCard.getElementsByClassName("content-wrapper").forEach(($wrapper) => {
						$wrapper.style.height = largestHeight + "px";
					});
				}
			});
		}
	}

	function initCarousel($elements, options) {
		const initializedCarousels = [];

		$elements.forEach(($element) => {
			var sliderMargin = 20;
			var previousNextButtonWidth = 64;
			const upTime = $element.dataset.pause;

			const defaults = {
				auto: true,
				autoReload: true,
				slideMargin: sliderMargin,
				pause: upTime ? upTime * 1000 : 5000,
				autoHover: true,
				useCSS: false,
				maxSlideWidth: 280,
				onSliderRedraw() {
					refreshSlider($element);
				},
				viewportMaxWidth(slideWidth, slider) {
					return (slideWidth + sliderMargin) * slider.settings.maxSlides + previousNextButtonWidth;
				},
			};

			const settings = Object.assign(defaults, options);
			$element.classList.add("is-slider");
			initializedCarousels.push($($element).bxSlider(settings));
		});

		return initializedCarousels;
	}
}

export default {
	view: "productPage",
	init,
};
